import React from 'react';
import Grid from '@bexs/dollar/components/Grid';
import Column from '@bexs/dollar/components/GridColumn';
import { CardListData } from '@bexs/dollar/components/CardList/types';
import { OperationTypeTyping } from 'store/ducks/statements/types';
import { CardList } from '@bexs/dollar';
import { CardTable } from 'pages/Balance/sections/TableResults/sections/OperationDetails/styles';

export interface OperationDetailsType {
  fullName: string;
  document: string;
  originBank: string;
  originAgency: string;
  originAccount: string;
  receiverBank: string;
  receiverAgency: string;
  receiverAccount: string;
  accountId: string;
  operationType: OperationTypeTyping;
  isIncomingOperation: boolean;
}

const getOriginColumn = (operation: OperationDetailsType) => {
  const data: CardListData[] = [
    {
      id: 'origin-name',
      label: 'Name',
      content: operation.fullName,
    },
    {
      id: 'origin-document',
      label: 'Document',
      content: operation.document,
    },
  ];
  if (operation.isIncomingOperation) {
    const incomingDetails: CardListData[] = [
      {
        id: 'origin-bank',
        label: 'Bank',
        content: operation.originBank,
      },
      {
        id: 'origin-agency',
        label: 'Agency',
        content: operation.originAgency,
      },
      {
        id: 'origin-account',
        label: 'Account',
        content: operation.originAccount,
      },
    ];
    data.push(...incomingDetails);
  } else {
    data.push({
      id: 'origin-account-id',
      label: 'Account Id',
      content: operation.accountId,
    });
  }

  return data;
};

const getDestinationColumn = (operation: OperationDetailsType) => {
  const data: CardListData[] = [
    {
      id: 'destination-name',
      label: 'Name',
      content: operation.fullName,
    },
    {
      id: 'destination-document',
      label: 'Document',
      content: operation.document,
    },
  ];

  if (!operation.isIncomingOperation) {
    const outcomeDetails: CardListData[] = [
      {
        id: 'destination-bank',
        label: 'Bank',
        content: operation.receiverBank,
      },
      {
        id: 'destination-agency',
        label: 'Agency',
        content: operation.receiverAgency,
      },
      {
        id: 'destination-account',
        label: 'Account',
        content: operation.receiverAccount,
      },
    ];
    data.push(...outcomeDetails);
  } else {
    data.push({
      id: 'destination-account-id',
      label: 'Account Id',
      content: operation.accountId,
    });
  }
  return data;
};

const OperationDetails = (operationDetails: OperationDetailsType) => {
  return (
    <CardTable isFullHeight={false}>
      <Grid
        style={{ padding: '0 12px' }}
        columns="1fr 1fr"
        gap="32px"
        data-testid="op-details"
      >
        <Column>
          <CardList title="Origin" data={getOriginColumn(operationDetails)} />
        </Column>
        <Column>
          <CardList
            title="Destination"
            data={getDestinationColumn(operationDetails)}
          />
        </Column>
      </Grid>
    </CardTable>
  );
};
export default OperationDetails;
